import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const HelpPage = lazyRouteComponent(() => import('../pages/help-page'))

export const helpPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'help/$page',
  component: HelpPage,
})
